// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"b7b1be3f","787":"5d79fe3e"}[chunkId] + ".chunk.js";
};